"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var LoginPage = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(LoginPage, _window$AbstractView);

    var _super = _createSuper(LoginPage);

    function LoginPage(id, options) {
      var _this;

      _classCallCheck(this, LoginPage);

      _this = _super.call(this, id, options);
      _this.$recoveryBtn = _this.$domElement.find(".login-page__password-recovery-btn");
      _this.$recoveryCollapse = _this.$domElement.find("#password-recovery-form-collapse");
      _this.$loginForm = _this.$domElement.find("#customer_login");
      _this.$recoverForm = _this.$domElement.find("#recover-form");
      _this.$loginEmail = _this.$loginForm.find('[name="customer[email]"]');
      _this.$loginPassword = _this.$loginForm.find('[name="customer[password]"]');
      _this.$recoverEmail = _this.$recoverForm.find('[name="email"]');
      _this.loginServerSideReport = _this.$loginForm.find("span[data-server-side-report]").data("serverSideReport");
      _this.recoveryServerSideReport = _this.$recoverForm.find("span[data-server-side-report]").data("serverSideReport");
      return _this;
    }

    _createClass(LoginPage, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.$recoveryBtn.on("click", function (event) {
          var $target = _this2.$recoveryBtn.attr("aria-expanded") == "true" ? 0 : _this2.$recoveryCollapse.get(0);
          window.TweenMax.to(window, 0.75, {
            scrollTo: {
              y: $target,
              offsetY: window.siteHeaderRef.$domElement.outerHeight() + 40,
              autoKill: false
            },
            ease: window.Cubic.easeInOut
          });
        });
        var loginValidatorRules = {
          'customer[email]': {
            required: true,
            email: true
          },
          'customer[password]': {
            required: true
          }
        };
        this.$loginForm.validate({
          rules: loginValidatorRules,
          errorElement: 'small',
          errorClass: 'form-text',
          highlight: function highlight(element) {
            $(element).closest('.form-group').addClass('form-error');
          },
          unhighlight: function unhighlight(element) {
            $(element).closest('.form-group').removeClass('form-error');
          },
          submitHandler: function submitHandler(form) {
            try {
              console.log('OK');
              form.submit();
            } catch (e) {
              console.log('form-error');
            }
          }
        });
        var recoverValidatorRules = {
          'email': {
            required: true,
            email: true
          }
        };
        this.$recoverForm.validate({
          rules: recoverValidatorRules,
          errorElement: 'small',
          errorClass: 'form-text',
          errorPlacement: function errorPlacement(error, element) {
            error.insertAfter(".input-group-btn");
          },
          highlight: function highlight(element) {
            $(element).closest('.form-group').addClass('form-error');
            $(element).closest('.input-group').addClass('form-error');
          },
          unhighlight: function unhighlight(element) {
            $(element).closest('.form-group').removeClass('form-error');
            $(element).closest('.input-group').removeClass('form-error');
          },
          submitHandler: function submitHandler(form) {
            try {
              form.submit();
            } catch (e) {
              console.log('form-error');
            }
          }
        });

        if (this.loginServerSideReport.errors) {
          $(window).triggerHandler("helper-modal.show", [{
            theme: "danger",
            closeBtn: true,
            header: "Errore di login",
            body: this.$loginForm.find("span[data-server-side-report]").html()
          }]);
        } else if (this.recoveryServerSideReport["posted_successfully?"]) {
          $(window).triggerHandler("helper-modal.show", [{
            theme: "success",
            closeBtn: true,
            header: "Recupero password",
            body: "A breve riceverai via email un link per resettare la password."
          }]);
        } else if (this.recoveryServerSideReport.errors) {
          $(window).triggerHandler("helper-modal.show", [{
            theme: "danger",
            closeBtn: true,
            header: "Errore nel recupero password",
            body: this.$recoverForm.find("span[data-server-side-report]").html()
          }]);
          this.$recoveryBtn.trigger("click");
        }

        _get(_getPrototypeOf(LoginPage.prototype), "init", this).call(this);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$recoveryBtn.off("click");
        this.$recoveryBtn = null;
        this.$recoveryCollapse = null;
        this.$loginForm = null;
        this.$recoverForm = null;
        this.$loginEmail = null;
        this.$loginPassword = null;
        this.$recoverEmail = null;

        _get(_getPrototypeOf(LoginPage.prototype), "dispose", this).call(this);
      }
    }]);

    return LoginPage;
  }(window.AbstractView);

  window.LoginPage = LoginPage;
})(window);
